/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutoCreatePlanCommand } from '../../models/auto-create-plan-command';
import { AutoCreatePlanCommandResult } from '../../models/auto-create-plan-command-result';

export interface ApiPlanAutoCreatePlanPost$Plain$Params {
  
    /**
     * Plan creation command
     */
    body?: AutoCreatePlanCommand
}

export function apiPlanAutoCreatePlanPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanAutoCreatePlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoCreatePlanCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanAutoCreatePlanPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutoCreatePlanCommandResult>;
    })
  );
}

apiPlanAutoCreatePlanPost$Plain.PATH = '/api/Plan/AutoCreatePlan';
